"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var context_1 = require("App/context");
var react_helmet_1 = require("react-helmet");
var antd_1 = require("antd");
require("antd/lib/result/style");
var react_router_dom_1 = require("react-router-dom");
var SystemLogout = function () {
    var ctx = react_1.useContext(context_1.ApplicationContext);
    var history = react_router_dom_1.useHistory();
    react_1.default.useEffect(function () {
        if (ctx.extraQueryParams === undefined) {
            ctx.extraQueryParams = {};
        }
        if (ctx.extraTokenParams === undefined) {
            ctx.extraTokenParams = {};
        }
        ctx.extraQueryParams.hootsuiteUserId = window.sessionStorage.getItem('hootsuiteUserId');
        ctx.extraQueryParams.hootsuiteTimestamp = window.sessionStorage.getItem('hootsuiteTimestamp');
        ctx.extraQueryParams.hootsuitePlacementId = window.sessionStorage.getItem('hootsuitePlacementId');
        ctx.extraQueryParams.hootsuiteToken = window.sessionStorage.getItem('hootsuiteToken');
        ctx.extraQueryParams.messageId = window.sessionStorage.getItem('messageId');
        ctx.extraTokenParams.hootsuiteUserId = window.sessionStorage.getItem('hootsuiteUserId');
        ctx.extraTokenParams.hootsuiteTimestamp = window.sessionStorage.getItem('hootsuiteTimestamp');
        ctx.extraTokenParams.hootsuitePlacementId = window.sessionStorage.getItem('hootsuitePlacementId');
        ctx.extraTokenParams.hootsuiteToken = window.sessionStorage.getItem('hootsuiteToken');
        ctx.extraTokenParams.messageId = window.sessionStorage.getItem('messageId');
        window.sessionStorage.removeItem('hootsuiteUserId');
        window.sessionStorage.removeItem('hootsuiteTimestamp');
        window.sessionStorage.removeItem('hootsuitePlacementId');
        window.sessionStorage.removeItem('hootsuiteToken');
        window.sessionStorage.removeItem('messageId');
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.Helmet, { title: "Hootsuite Logout successful" }),
        react_1.default.createElement(antd_1.Result, { status: "success", title: "Hootsuite Logout successful", subTitle: "You have been logged out. See you soon!", extra: [
                react_1.default.createElement(antd_1.Button, { key: "login", onClick: function () { return history.push('/login'); } }, "Login again"),
            ] })));
};
exports.default = {
    name: 'Logout',
    routeProps: {
        path: '/logout_successful',
        component: SystemLogout,
    },
};
//# sourceMappingURL=index.js.map